{
  "name": "client-app",
  "version": "0.0.0",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "build-prod": "ng build --configuration=production",
    "watch": "ng build --watch --configuration development",
    "test": "ng test"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^21.2.2",
    "@angular/common": "^21.2.2",
    "@angular/compiler": "^21.2.2",
    "@angular/core": "^21.2.2",
    "@angular/forms": "^21.2.2",
    "@angular/material": "^21.2.1",
    "@angular/material-moment-adapter": "^21.2.1",
    "@angular/platform-browser": "^21.2.2",
    "@angular/platform-browser-dynamic": "^21.2.2",
    "@angular/router": "^21.2.2",
    "@flaticon/flaticon-uicons": "^3.1.0",
    "@ngx-translate/core": "^15.0.0",
    "bootstrap": "^5.3.3",
    "moment": "2.30.1",
    "ng2-pdf-viewer": "^10.4.0",
    "ngx-mask": "^21.0.1",
    "raygun4js": "^3.1.3",
    "rxjs": "~7.5.0",
    "tslib": "^2.3.0",
    "zone.js": "^0.15.0"
  },
  "devDependencies": {
    "@angular/build": "^21.2.1",
    "@angular/cli": "~21.2.1",
    "@angular/compiler-cli": "^21.2.2",
    "@types/jasmine": "~4.0.0",
    "jasmine-core": "~4.2.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.1.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.0.0",
    "typescript": "^5.9.3"
  }
}
